export default {"src":"/_next/static/media/placeholder-category.8fcb4ac5.svg","height":356,"width":1920};